export default {
  cake: {
    97: '0x761757e7eE77b1dbfc4411c3fcE050695491Fa95',
    56: '0x660F25d08D2d8A2dD55659B6F0dd94f973fa9B32', // checked
  },
  syrup: {
    97: '',
    56: '',
  },
  masterChef: {
    97: '0x375ed2aFCBf6B2775629Ba20e04888E2ef4144Fc',
    56: '0x464bD9e218DF15606213326234C81ad1F19633BB', // checked
  },
  sousChef: {
    97: '',
    56: '',
  },
  wbnb: {
    97: '0xae13d989dac2f0debff460ac112a837c89baa7cd', // not changed
    56: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
  },
  lottery: {
    97: '0x99c2EcD51d52c036B00130d882Bc65f20Fdecf9f', // not changed
    56: '0x3C3f2049cc17C136a604bE23cF7E42745edf3b91',
  },
  lotteryNFT: {
    97: '0x8175c10383511b3a1C68f9dB222dc14A19CC950e', // not changed
    56: '0x5e74094Cd416f55179DBd0E45b1a8ED030e396A1',
  },
  mulltiCall: {
    56: '0x1ee38d535d541c55c9dae27b12edf090c608e6fb', // not changed
    97: '0x67ADCB4dF3931b0C5Da724058ADC2174a9844412',
  },
  busd: {
    56: '0xe9e7cea3dedca5984780bafc599bd69add087d56', // not changed
    97: '',
  },
  ust: {
    56: '0x23396cF899Ca06c4472205fC903bDB4de249D6fC', // not changed
    97: '',
  },
  pancakeProfile: {
    56: '0xDf4dBf6536201370F95e06A0F8a7a70fE40E388a', // not changed
    97: '0x4B683C7E13B6d5D7fd1FeA9530F451954c1A7c8A',
  },
  pancakeRabbits: {
    56: '0xDf7952B35f24aCF7fC0487D01c8d5690a60DBa07', // not changed
    97: '0x60935F36e4631F73f0f407e68642144e07aC7f5E',
  },
  bunnyFactory: {
    56: '0xfa249Caa1D16f75fa159F7DFBAc0cC5EaB48CeFf', // not changed
    97: '0x707CBF373175fdB601D34eeBF2Cf665d08f01148',
  },
  eth: {
    56: '0x2170ed0880ac9a755fd29b2688956bd959f933f8', // not changed
    97: '',
  },
  claimRefund: {
    56: '0xE7e53A7e9E3Cf6b840f167eF69519175c497e149', // not changed
    97: '',
  },
  pointCenterIfo: {
    56: '0x3C6919b132462C1FEc572c6300E83191f4F0012a', // not changed
    97: '0xd2Ac1B1728Bb1C11ae02AB6e75B76Ae41A2997e3',
  },
  bunnySpecial: {
    56: '0xFee8A195570a18461146F401d6033f5ab3380849', // not changed
    97: '0x7b7b1583De1DeB32Ce6605F6deEbF24A0671c17C',
  },
}
